module.exports = __webpack_public_path__ + "img/default_sorteio_web.d31e412d.png";